(function () {
  const playSlideVideo = (slide) => {
    const video = slide && slide.querySelector('video');
    if (video && typeof video.play === 'function') {
      video.play().catch(() => {});
    }
  };

  const pauseSlideVideo = (slide) => {
    const video = slide && slide.querySelector('video');
    if (video && typeof video.pause === 'function') {
      video.pause();
    }
  };

  const initFeatureMediaTabs = (media) => {
    if (!media || media.dataset.mediaTabsInitialized) return;
    media.dataset.mediaTabsInitialized = 'true';

    const tabs = media.querySelectorAll('.feature-media-tabs__tab');
    const slides = media.querySelectorAll('.feature-media-tabs__slide');
    const tabsList = media.querySelector('.feature-media-tabs__tabs');
    const tabsWrap = media.querySelector('.feature-media-tabs__tabs-wrap');

    const updateScrollFade = () => {
      if (!tabsList || !tabsWrap) return;
      const maxScroll = tabsList.scrollWidth - tabsList.clientWidth;
      tabsWrap.classList.toggle('feature-media-tabs__tabs-wrap--scroll-start', tabsList.scrollLeft > 1);
      tabsWrap.classList.toggle(
        'feature-media-tabs__tabs-wrap--scroll-end',
        tabsList.scrollLeft < maxScroll - 1
      );
    };

    if (tabsList) {
      tabsList.addEventListener('scroll', updateScrollFade, { passive: true });
      window.addEventListener('resize', updateScrollFade);
      updateScrollFade();
    }

    slides.forEach((slide) => {
      if (slide.classList.contains('active')) {
        playSlideVideo(slide);
      } else {
        pauseSlideVideo(slide);
      }
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        if (tab.classList.contains('active')) return;
        const targetId = tab.dataset.mediaTabId;

        tabs.forEach((el) => {
          el.classList.remove('active');
          el.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

        slides.forEach((slide) => {
          if (slide.dataset.mediaTabId === targetId) {
            slide.classList.add('active');
            playSlideVideo(slide);
          } else {
            slide.classList.remove('active');
            pauseSlideVideo(slide);
          }
        });
      });
    });
  };

  const initAll = (root) => {
    (root || document)
      .querySelectorAll('.feature-media-tabs__media')
      .forEach(initFeatureMediaTabs);
  };

  initAll();

  document.addEventListener('shopify:section:load', (event) => {
    event.target
      .querySelectorAll('.feature-media-tabs__media')
      .forEach((media) => {
        delete media.dataset.mediaTabsInitialized;
        initFeatureMediaTabs(media);
      });
  });
})();
